"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Dialog, DialogTrigger, DialogContent } from "@/components/ui/dialog";
const galleryImages = [{
  id: "img-1",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-56_1.jpg?v=tfmp4pc7cr",
  alt: "Spacious open-concept living area at Paradise Palms Jamaica",
  category: "Living Room"
}, {
  id: "img-2",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-40-41_4.jpg?v=7y4nqbso0bo",
  alt: "Chef-ready kitchen with modern appliances and island seating",
  category: "Kitchen"
}, {
  id: "img-3",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-05_2.jpg?v=wpozvdufgim",
  alt: "The elegant exterior of Paradise Palms in Montego Bay",
  category: "Exterior"
}, {
  id: "img-4",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/03/image1.jpeg.png?v=84t8fbb2zd",
  alt: "Nearby pristine beaches just a short ride from the villa",
  category: "Exterior"
}, {
  id: "img-5",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-33-35_1.jpg?v=b92524n99p",
  alt: "Master bedroom suite with premium linens and tropical views",
  category: "Bedrooms"
}, {
  id: "img-8",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-33-35.jpg?v=1f5scsbsijh",
  alt: "Spa-like bathroom with luxury finishes and walk-in shower",
  category: "Bedrooms"
}, {
  id: "img-9",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-35_1.jpg?v=xja1n6px0b8",
  alt: "Paradise Palms beautifully illuminated for evening relaxation",
  category: "Exterior"
}, {
  id: "img-10",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-35.jpg?v=6sdvjnzmklr",
  alt: "Scenic views of the Montego Bay coastline",
  category: "Exterior"
}, {
  id: "img-11",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-33-34.jpg?v=7i6e0hgiwba",
  alt: "Bright and airy guest bedroom designed for comfort",
  category: "Bedrooms"
}, {
  id: "img-12",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-36_2.jpg?v=r56bd16sxj",
  alt: "Comfortable outdoor lounge area for morning coffee",
  category: "Exterior"
}, {
  id: "img-13",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-36-44.jpg?v=44ieztpjmzx",
  alt: "Modern luxury bathroom with elegant marble finishes and walk-in rain shower",
  category: "Bathrooms"
}, {
  id: "img-14",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-36-44_4.jpg?v=yta9hvsbj2h",
  alt: "Sleek vanity area with contemporary lighting and high-end fixtures",
  category: "Bathrooms"
}, {
  id: "img-15",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-55_4.jpg?v=tlu2ltrazi",
  alt: "Plush designer sofa in the main living area",
  category: "Living Room"
}, {
  id: "img-16",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-55_3.jpg?v=y5gfr90o15",
  alt: "Modern entertainment center with large screen TV",
  category: "Living Room"
}, {
  id: "img-17",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-55.jpg?v=xteymf5cs",
  alt: "Handcrafted coffee table with Jamaican decor",
  category: "Living Room"
}, {
  id: "img-18",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-55_1.jpg?v=k6grqbv0ytc",
  alt: "Warm accent lighting creating a cozy evening ambiance",
  category: "Living Room"
}, {
  id: "img-23",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-40-41_1.jpg?v=k9eqwhgzd9h",
  alt: "Professional grade stovetop for gourmet cooking",
  category: "Kitchen"
}, {
  id: "img-24",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-40-41_2.jpg?v=94d0brwrccp",
  alt: "Large stainless steel refrigerator for guest use",
  category: "Kitchen"
}, {
  id: "img-25",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-39-38.jpg?v=9yb4ter4xzh",
  alt: "Dedicated coffee station with premium maker",
  category: "Kitchen"
}, {
  id: "img-26",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-39-38_1.jpg?v=pksxn8hv2nj",
  alt: "Sleek breakfast bar with comfortable stool seating",
  category: "Kitchen"
}, {
  id: "img-32",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-36_1.jpg?v=n3wy2h54kjn",
  alt: "Manicured garden path leading to the villa entrance",
  category: "Exterior"
}, {
  id: "img-33",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-36.jpg?v=spllfa96rx",
  alt: "Al fresco dining setup on the main patio",
  category: "Exterior"
}, {
  id: "img-34",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-05_4.jpg?v=6tpleatwbyd",
  alt: "Lush tropical plants surrounding the property",
  category: "Exterior"
}, {
  id: "img-35",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-38-05_3.jpg?v=h16z7hicvj5",
  alt: "Secure gated entrance for peace of mind",
  category: "Exterior"
}, {
  id: "img-36",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-36-21_2.jpg?v=9qjg09jihy",
  alt: "Second master suite with king-sized bed",
  category: "Bedrooms"
}, {
  id: "img-37",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-36-21_1.jpg?v=x70rbluh0g8",
  alt: "Spacious walk-in closet with organizing shelves",
  category: "Bedrooms"
}, {
  id: "img-38",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-36-20_1.jpg?v=pi39qjgbd0k",
  alt: "Bedside table with reading lamp and USB ports",
  category: "Bedrooms"
}, {
  id: "img-39",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-35-59_3.jpg?v=ymglu2jyk7",
  alt: "Guest room configured with two comfortable twin beds",
  category: "Bedrooms"
}, {
  id: "img-40",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-35-59_1.jpg?v=sdtq80ws5ce",
  alt: "High thread-count luxury linens for a restful sleep",
  category: "Bedrooms"
}, {
  id: "img-41",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-35-58.jpg?v=xi2hifmo9t",
  alt: "Quiet corner desk for remote work or planning",
  category: "Bedrooms"
}, {
  id: "img-42",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/f3daf016-231a-443f-a956-4b872cec9559.jpeg?v=m0y5on7z3h",
  alt: "Waking up to beautiful tropical views",
  category: "Bedrooms"
}, {
  id: "img-43",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-36-44_3.jpg?v=ask0co2xtl",
  alt: "En-suite bathroom featuring a modern glass shower",
  category: "Bathrooms"
}, {
  id: "img-44",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-36-44_2.jpg?v=j6ni732eh8",
  alt: "Heated towel rack with plush white towels",
  category: "Bathrooms"
}, {
  id: "img-45",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-35-26.jpg?v=0bo691dn7szf",
  alt: "Backlit mirror for perfect grooming",
  category: "Bathrooms"
}, {
  id: "img-46",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-35-29.jpg?v=y7hcw8bv8ps",
  alt: "Complimentary luxury toiletries for guests",
  category: "Bathrooms"
}, {
  id: "img-47",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-35-28_1.jpg?v=3b0yziumc5d",
  alt: "Exquisite tile work in the master bathroom",
  category: "Bathrooms"
}, {
  id: "img-48",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/PHOTO-2026-04-04-16-35-28.jpg?v=ogb8z751y0c",
  alt: "Convenient guest powder room on the main floor",
  category: "Bathrooms"
}, {
  id: "img-49",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/36b24949-29c9-4aee-84e0-da4271d4423a.jpeg?v=8d0brxdke8e",
  alt: "Double vanity in the shared family bathroom",
  category: "Bathrooms"
}, {
  id: "img-50",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/da70cedd-0eaa-486d-b113-976208c64df2.jpeg?v=nu99wzzbnjj",
  alt: "Frosted windows providing natural light and privacy",
  category: "Bathrooms"
}, {
  id: "img-73",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/dd1f48bc-8a09-444b-a6b8-da773d83fa61.jpeg?v=kaxiwalqxhd",
  alt: "Array of premium down-alternative pillows",
  category: "Bedrooms"
}, {
  id: "img-74",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/b40880f7-4633-4c0e-897b-5f60ad350686.jpeg?v=o9m6ta5h54p",
  alt: "Modern bedside lamp with adjustable brightness",
  category: "Bedrooms"
}, {
  id: "img-93",
  src: "https://paradisepalmsmobay.com/wp-content/uploads/2026/04/a9de2d41-509a-4804-929d-b88f39cccab5.jpeg?v=e3gzkldhfzf",
  alt: "Rainfall shower head for a spa experience",
  category: "Bathrooms"
}];
const categories = ["All", "Living Room", "Bedrooms", "Bathrooms", "Kitchen", "Exterior"];
export default function TheVisualStory() {
  const renderGrid = (category: string) => {
    const filteredImages = galleryImages.filter(img => img.src && img.src.trim() !== "" && (img.src.startsWith("http") || img.src.startsWith("/")) && (category === "All" || img.category === category));
    return <div data-section-id="153670" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {filteredImages.map((image, i) => <div key={image.id} data-index={i}>
            <Dialog>
              <DialogTrigger asChild>
                <button className="group relative w-full aspect-square overflow-hidden rounded-3xl bg-secondary cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 block border-0 p-0 shadow-sm transition-shadow hover:shadow-xl" aria-label={`View larger image of ${image.alt}`}>
                  <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" />
                  <div className="absolute inset-0 bg-primary/0 transition-colors duration-300 group-hover:bg-primary/20 flex items-center justify-center">
                    <div className="bg-white/90 backdrop-blur-sm text-primary p-3 rounded-full shadow-lg opacity-0 transform scale-90 transition-all duration-300 group-hover:opacity-100 group-hover:scale-100">
                      <Plus className="w-5 h-5" />
                    </div>
                  </div>
                </button>
              </DialogTrigger>
              <DialogContent className="max-w-5xl p-2 sm:p-4 bg-background border-border shadow-2xl rounded-3xl">
                <div className="overflow-hidden rounded-2xl bg-muted/30 flex items-center justify-center min-h-[50vh]">
                  <img src={image.src} alt={image.alt} className="w-full h-auto max-h-[80vh] object-contain" />
                </div>
              </DialogContent>
            </Dialog>
          </div>)}
      </div>;
  };
  return <section id="explore-the-villa" className="bg-background py-16 md:py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-sans font-bold text-foreground mb-4 tracking-tight">
            Explore the Villa
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans leading-relaxed">
            Step inside our Montego Bay sanctuary. A visual journey through our 4-bedroom retreat, designed for the ultimate Jamaican getaway.
          </p>
        </div>

        <Tabs defaultValue="All" className="w-full">
          <div className="flex justify-center mb-10 overflow-x-auto pb-2 -mx-4 px-4 sm:mx-0 sm:px-0 sm:pb-0 sm:overflow-visible">
            <TabsList className="bg-secondary p-1.5 rounded-2xl inline-flex min-w-max shadow-sm">
              {categories.map((tab, i) => <TabsTrigger key={tab} value={tab} className="rounded-xl px-6 py-2.5 text-sm font-semibold tracking-wide transition-all data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:shadow-md" data-index={i}>
                  {tab}
                </TabsTrigger>)}
            </TabsList>
          </div>
          
          {categories.map((tab, i) => <TabsContent key={tab} value={tab} className="mt-0 outline-none focus-visible:ring-0" data-index={i}>
              {renderGrid(tab)}
            </TabsContent>)}
        </Tabs>
      </div>
    </section>;
}